import React from 'react'
import { ManageState } from './manageState'
import TableCustom from '../../../../components/table/tableCustom';
import ContainerButton from '../../../../components/button/ContainerButton';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';

type Props = {
    code: string;
}

const PermissionList: React.FC<Props> = ({ code }: Props) => {
    const navigate: NavigateFunction = useNavigate();
    const {
        data,
        handleRequestSort,
        headCell,
        page,
        pageLimit,
        renderData,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        totalItems,
        checkPermit
    } = ManageState(code);
    return (
        <ContainerLayout
            title='บทบาทผู้ใช้งาน'
            content={
                <>
                    <div style={{ display: 'flex', width: "100%", justifyContent: 'end', margin: '10px 0px' }}>
                        <div>
                            <ContainerButton
                                buttonData={[
                                    {
                                        seq: 1,
                                        hidden: !checkPermit.isCreated,
                                        buttonProps: {
                                            onClick: () => navigate(routeName.cms_website.permissionCreate)
                                        },
                                        key: "ADD",
                                        label: "เพิ่มบทบาท",
                                        type: "ADD"
                                    }
                                ]}
                            />
                        </div></div>
                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1240}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCell}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </>
            }


        />
    )
}

export default PermissionList